import { Component } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Sharedservice } from 'src/app/shared-components/shared.service';

@Component({
  selector: 'app-sessionExpired',
  templateUrl: './sessionExpired.component.html',
  styleUrls: ['./sessionExpired.component.css']
})
export class SessionExpiredComponent {

  constructor(private adalSvc: MsalService, public sharedService: Sharedservice) {

  }
  ngOnInit() {
    this.sharedService.isSessionExpired = true;
  }
  login() {
    localStorage.clear();
    this.adalSvc.logout();
  }
}
